// stores/equipamentosStore.js
import { defineStore } from 'pinia';

export const useEquipamentosStore = defineStore('equipamentos', {
  state: () => ({
    filters: {
      serial_number: '',
      tipo: '',
      modelo: '',
      status: '',
      unidade: '',
      token: '',
      search: '',
    },
    sortColumn: 'serial_number',
    sortDirection: 'asc',
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    totalCount: 0,
    equipamentos: [] // Centralizado aqui!
  }),

  actions: {
    setEquipamentos(equipamentos) {
      this.equipamentos = equipamentos;
    },
    setFilter(key, value) {
      this.filters[key] = value;
    },
    

    setFilters(newFilters) {
      this.filters = { ...this.filters, ...newFilters };
    },

    clearFilters() {
      this.filters = {
        serial_number: '',
        tipo: '',
        modelo: '',
        status: '',
        unidade: '',
        token: '',
        search: '',
      };
    },

    setSort(column, direction) {
      this.sortColumn = column;
      this.sortDirection = direction;
    },

    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
    setCurrentPage(page) {
      this.currentPage = page;
    },
    setPageSize(size) {
      this.pageSize = size;
    },
    setTotalPages(total) {
      this.totalPages = total;
    },
    setTotalCount(count) {
      this.totalCount = count;
    }
  },
  persist:true
});
